import { Eye, HeartHandshake, Gem } from "lucide-react";
import "aos/dist/aos.css";
import TalkCallToAction from "../talk-cta/TalkCallToAction";
import imgPrincipal from "../../assets/images/all/principal.png";
import "./About.scss";

const About = () => {
  return (
    <section id="about">
      <div className="about">
        <div className="page-header" data-aos="fade-up">
          <div className="about-intro-copy">
            <h1>Bem-estar corporativo que nasce da realidade da sua empresa</h1>
            <p>
              A Sodalita Bem‑Estar Corporativo é uma empresa especializada em bem‑estar
              físico e emocional para empresas, com soluções desenvolvidas exclusivamente
              para o ambiente de trabalho.<br/>
              Nossa atuação combina experiência em gestão corporativa com a especialidade no
              cuidado com pessoas, o que nos permite compreender, na prática, os desafios das
              organizações modernas e atuar de forma estratégica, sem perder de vista a realidade
              operacional das empresas.
            </p>
            <p>
              Utilizamos protocolos próprios adaptados ao ambiente empresarial,
              promovendo a integração entre saúde física, emocional e cultura
              organizacional, com atendimento humanizado e padrão profissional,
              oferecemos personalização real, sem soluções genéricas e aliada a
              acompanhamento por indicadores de evolução contínua.
            </p>
          </div>
          <div className="about-feature-image">
            <img src={imgPrincipal} alt="Bem-estar corporativo Sodalita" />
          </div>
        </div>

        <div className="about-structure" data-aos="fade-up">
          <div className="about-intro-section">
            <h2>Missão, Visão e Valores</h2>
            <p>
              Com foco em resultados práticos, <strong>transformamos normativas e metas de
              cuidado com as pessoas em uma estratégia estruturada</strong>, adaptável e
              alinhada à realidade corporativa.
            </p>
          </div>

          <div className="about-cards">
            <div className="card" data-aos="fade-up">
              <div className="card-badge">
                <HeartHandshake size={38} color="#78b5ae" />
              </div>
              <h3>Missão</h3>
              <p>
                Transformar o ambiente de trabalho em um espaço mais saudável, humano e
                produtivo, onde o cuidado com as pessoas faça parte da cultura
                organizacional, e não seja uma ação pontual.
              </p>
            </div>

            <div className="card" data-aos="fade-up">
              <div className="card-badge">
                <Eye size={38} color="#78b5ae" />
              </div>
              <h3>Visão</h3>
              <p>
                Ser referência em bem‑estar corporativo humanizado, reconhecida por apoiar
                empresas na construção de ambientes de trabalho mais saudáveis, conscientes,
                equilibrados e sustentáveis, valorizando o ser humano de forma integral.
              </p>
            </div>

            <div className="card valores" data-aos="fade-up">
              <div className="card-badge">
                <Gem size={38} color="#78b5ae" />
              </div>
              <h3>Valores</h3>
              <ul>
                <li>Respeito à individualidade de cada colaborador e à cultura de cada organização</li>
                <li>Atuação com ética, empatia e acolhimento em cada interação</li>
                <li>Compromisso com qualidade, confidencialidade e evolução contínua</li>
                <li>Valorização do ser humano como parte essencial dos resultados</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <TalkCallToAction />
    </section>
  );
};

export default About;

